import React, { useCallback, useState } from 'react';
import { TextField } from '@framework-controls/core';
import { strings } from 'src/localization/index';
import css from './DesktopDiagnoseModal.module.scss';
import { VehicleRec, ascFormEngagementInput } from 'src/models';
import { ascFormEngagement } from 'src/helpers/EventHelper/EventHelper';

interface IProps {
    additionalComments: React.MutableRefObject<string>;
    title: string;
    vehicles: VehicleRec[];
    selectedVehicle: string | undefined;
    setError: React.Dispatch<React.SetStateAction<boolean>>;
}

const DiagnoseEnd = (props: IProps) => {
    const [additionalComments, setAdditionalComments] = useState('');

    const onChangeHandler = useCallback((value: string) => {
        setAdditionalComments(value);
        props.additionalComments.current = value;

        if ((/\S/.test(additionalComments) &&
                    additionalComments.length > 1 && /\S/.test(value)) || /\S/.test(value)) {
            props.setError(false);
        }
    }, [additionalComments, setAdditionalComments, props]);

    const commentsBlurHandler = useCallback(() => {
        const ascFormEngagementInp: ascFormEngagementInput = {
            pageType: 'service',
            commType: 'form',
            commStatus: 'engage',
            elementText: strings.AnyAdditional,
            department: 'service',
            formName: 'Service_Portal_2',
            formType: 'service_appointment',
        };
        ascFormEngagement(ascFormEngagementInp, props.vehicles, props.selectedVehicle);
    }, [props.vehicles, props.selectedVehicle]);

    return (
        <div>
            <p>{strings.YourIssue}</p>
            <div className={css.finalIssue}>
                <div id='titleDiv' className={css.issueTitle}>{props.title}</div>
            </div>
            <p>{strings.AnyAdditional}</p>
            <div className={css.comments}>
                <TextField
                    value={additionalComments}
                    id='comments'
                    size='full'
                    multiline
                    type='text'
                    onChange={(_, value) => onChangeHandler(value)}
                    onBlur={commentsBlurHandler}
                    rows={5}
                    disableUnderline
                />
            </div>
        </div>
    );
};

export default DiagnoseEnd;